export default __webpack_public_path__ + "static/nasa_logo.inline-fb3159ba22eceee589d72eb939d7593e.png";